document.addEventListener("DOMContentLoaded", function() {
  
  // Create ONE master observer for all dynamic app injections
  const adaObserver = new MutationObserver(function(mutations) {
    
    // 1. Fix Kaching Cart Toggle
    // The :not() selector ensures we only target it if it hasn't been fixed yet
    const cartButton = document.querySelector('.kaching-cart-toggle:not([aria-label])');
    if (cartButton) {
      cartButton.setAttribute('aria-label', 'Open cart');
    }

    // 2. Fix Progress Bar App (From your Axe DevTools Screenshot)
    const pBarNext = document.querySelector('#PBarNextFrame button:not([aria-label])');
    if (pBarNext) {
      pBarNext.setAttribute('aria-label', 'Next slide');
    }
    
    // Pro-active fix: Catch the "Previous" and "Close" buttons for that same app
    const pBarPrev = document.querySelector('#PBarPrevFrame button:not([aria-label])');
    if (pBarPrev) {
      pBarPrev.setAttribute('aria-label', 'Previous slide');
    }
    const pBarClose = document.querySelector('.PBarClose button:not([aria-label]), #PBarCloseFrame button:not([aria-label])');
    if (pBarClose) {
      pBarClose.setAttribute('aria-label', 'Close banner');
    }

    // 3. Fix Splide Slider ARIA Roles
    const splideSlides = document.querySelectorAll('.splide__slide[role="tabpanel"]');
    if (splideSlides.length > 0) {
      splideSlides.forEach(slide => {
        slide.setAttribute('role', 'group'); 
        slide.setAttribute('aria-roledescription', 'slide');
      });
    }

    // 4. Common Shopify App Fallbacks (Catch-all for empty icon buttons)
    // Many review apps and popups use generic classes like .slick-next or .modal-close
    const genericCloseBtns = document.querySelectorAll('.modal-close:not([aria-label]), .close-popup:not([aria-label])');
    genericCloseBtns.forEach(btn => btn.setAttribute('aria-label', 'Close popup'));

  });

  // Start watching the entire body with the single, optimized observer
  adaObserver.observe(document.body, { childList: true, subtree: true });
  
});0